import Tooltip from '@ab-core/tooltip';
import type { FC } from 'react';
import React, { useState } from 'react';
import type { CounterType } from '../..';
import { Counter } from '../..';
import { getNextPossibleNumber } from '../../utils';
import { TooltipContent } from './tooltipContent';

export const CounterWithTooltip: FC<CounterType> = (props) => {
    const { stateUpdate, quantityUnit, ...rest } = props;

    const [showTooltip, setShowTooltip] = useState(false);
    const [nextPossibleValue, setNextPossibleValue] = useState<number>();

    const tooltipStateUpdate: CounterType['stateUpdate'] = (state) => {
        const { quantity } = state;

        const newQuantity = getNextPossibleNumber({ ...state });

        setNextPossibleValue(newQuantity);

        if (newQuantity === quantity) {
            setShowTooltip(false);
        } else {
            setShowTooltip(true);
        }

        if (stateUpdate) {
            stateUpdate(state);
        }
    };

    return (
        <Tooltip
            showTooltip={showTooltip}
            placement="top"
            content={<TooltipContent nextPossibleValue={nextPossibleValue} quantityUnit={quantityUnit} />}
        >
            <Counter {...rest} stateUpdate={tooltipStateUpdate} quantityUnit={quantityUnit} />
        </Tooltip>
    );
};
